import "./How01.css";

function How01() {
  return (
    <div className="How01 section">
      <div className="container">
        <div className="intro">
          <p className="eyebrow grey">How It Works?</p>
          <h2>Our Simple 3-Step Process</h2>
          <p>
            We offer a complete solution for your waste tyre management needs.
            We ensure your end-of-life tyres are handled responsibly,
            compliantly, and in an environmentally effective way, turning waste
            into valuable resources.
          </p>
        </div>

        <div className="How01-box">
          <div>
            <div className="How01-box-icon green">
              <div>
                <p>1</p>
              </div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="How01-box-text green">
              <h3>Request </h3>
              <p>
                Use our online form or call our team to provide details about
                your tyre volume and location. We'll return a transparent,
                no-obligation quote.
              </p>
            </div>
          </div>

          <div>
            <div className="How01-box-icon">
              <div>
                <p>2</p>
              </div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="How01-box-text">
              <h3>Schedule </h3>
              <p>
                We work with you to schedule a collection at a time that
                minimises disruption to your business operations.
              </p>
            </div>
          </div>

          <div>
            <div className="How01-box-icon">
              <div>
                <p>3</p>
              </div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="How01-box-text">
              <h3>Collection </h3>
              <p>
                Our trained and licensed team arrives on-site to safely and
                efficiently collect your tyres, providing you with your Waste
                Transfer Note.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default How01;
